var Timer = function(opts) {

    opts = opts || {};

    var _this = this,
        timer,
        currentTime = 0,
        duration = opts.duration,

        startTime = 0,
        stopTime  = 0;

    if(typeof opts === 'number') {
        duration = opts;
    }

    this.onEnd  = opts.onEnd;
    this.onStop = opts.onStop;

    var increment = function() {
        currentTime++;

        if(opts[currentTime]) {
            opts[currentTime]();
        }

        if(currentTime >= duration) {
            _this.reset();

            if(_this.onEnd) {
                _this.onEnd();
            }
        }
    };

    this.reset = function() {
        currentTime = 0;
        clearInterval(timer);
    };

    this.start = function() {
        this.reset();
        timer = setInterval(increment, 1000);
        startTime = (new Date()).getTime();
    };

    this.stop = function() {
        this.reset();
        stopTime = (new Date()).getTime();

        if(this.onStop) {
            this.onStop(stopTime - startTime);
        }
    };

    this.getTime = function() {
        return currentTime;
    };

    if(opts.start) {
        this.start();
    }
};